module.exports = __webpack_public_path__ + "img/report-export.02b96f08.svg";